import React, { useState } from "react";

import { auth } from "../../../Firebase/firebase";
import { connect } from "react-redux";
import * as actionCreators from "../../../Store/actions/index";
import {priceFormater} from "../../Utility/Utility";
import HeartSpin from "../../UI/spinner/HeartSpin";
import classes from "./RecentVehicle.module.css";
import carImg from "../../../assets/Img/carIMg.png";
import camera from "../../../assets/svg/camera.svg";
import heart from "../../../assets/svg/balckHeart.svg";
import redHeart from "../../../assets/svg/redHeart.svg";
import fullStar from ".././../../assets/svg/star.svg";
import halfStar from ".././../../assets/svg/starHalf.svg";
import emptyStar from ".././../../assets/svg/starOutline.svg";
// import like from "../../../assets/svg/like.svg"

const RecentVehicle = (props) => {
    const [currentItemWishing, setCurrentItemWishing] = useState(null);
    const checkItemIsWishLIsted = (itemId) => {
        let isWishItem = false;
        let wishArray = localStorage.getItem('myWish');
        if (props.user && props.wishIdsArray && wishArray) {
            wishArray = wishArray.split(',');
            isWishItem = wishArray.some((id) => {
                return +id === itemId
            })
        }
        return isWishItem
    }
    const addItmeToWishList = (itemId, userIsAuth) => {
        if (!props.user) {
            props.showAuthHandler('signIn')
        }
        else {
            const itemIsWishListed = checkItemIsWishLIsted(itemId);
            if (!itemIsWishListed) {
                let token = localStorage.getItem('idToken')
                if (!token) {
                    const fireUser = auth.currentUser
                    if (fireUser) {
                        fireUser.getIdToken().then(newToken => {
                            token = newToken
                            props.AddItemToWishList(itemId, token)
                        })
                    }
                    else {
                        console.log(fireUser)
                    }
                }
                else {
                    props.AddItemToWishList(itemId, token)
                }
            }
            else {
                console.log(itemId, userIsAuth, 'in my WishList')
            }
        }
    };
    return (
        <div className={classes.RecentVehicleList}>
            {props.FeatruedVehicles.map((FeatruedVehicle) => {
                const ImgUrl = (FeatruedVehicle.media.length !== 0 ?
                    FeatruedVehicle.media[0]['url']
                    : carImg
                );
                const tailer = ImgUrl.slice(-4);
                let isWishListed = false;
                let wishArray = localStorage.getItem('myWish');
                if (props.user && props.wishIdsArray && wishArray) {
                    wishArray = wishArray.split(',');
                    isWishListed = wishArray.some((id) => {
                        return +id === FeatruedVehicle.id
                    })
                }
                return (
                    <div
                        key={FeatruedVehicle.id}
                        className={classes.RecentVehicleItem}>
                        <div className={classes.itemImage} onClick={() => {
                            props.routeHistory.push(`/Detail?vehicle=${FeatruedVehicle.id}&type=${FeatruedVehicle.vehicle_type}`)
                            if (props.reload) {
                                props.reload()
                            }
                        }}>
                            <div className={classes.positioningCamera}>
                                <img src={camera} alt='num' /><small>{FeatruedVehicle.media.length} +</small>
                            </div>
                            {tailer === '.mp4' ?
                                <video width='100%' height='100%'>
                                    <source src={ImgUrl} type='video/mp4' />
                                </video>
                                :
                                <img src={ImgUrl} alt='car images' width='100%' height='200px' />
                            }
                            {props.addingItem && currentItemWishing === FeatruedVehicle.id ?
                                <div className={classes.AddingWish}>
                                    <HeartSpin />
                                </div>
                                :
                                <div
                                    className={classes.positioningHeart}
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        setCurrentItemWishing(FeatruedVehicle.id)
                                        addItmeToWishList(FeatruedVehicle.id, props.user !== null)
                                    }}>
                                    <img src={isWishListed ? redHeart : heart} alt='num' />
                                </div>
                            }
                        </div>
                        <div
                            className={classes.ItemInfo}
                            onClick={() => {
                                props.routeHistory.push(`/Detail?vehicle=${FeatruedVehicle.id}&type=${FeatruedVehicle.vehicle_type}`)
                                if (props.reload) {
                                    props.reload()
                                }
                            }}>
                            <h6>{FeatruedVehicle.title}</h6>
                            <div className={classes.itemDetails}>
                                <p>Mileage</p>
                                <small>Featured</small>
                                <p>{FeatruedVehicle.mileage}</p>
                                <small>{FeatruedVehicle.condition}</small>
                                <p>{FeatruedVehicle.state ? FeatruedVehicle.state.name : null}</p>
                                <small>{FeatruedVehicle.body_type}</small>
                            </div>
                        </div>
                        <div className={classes.Price}><p>{priceFormater(FeatruedVehicle.price)}</p></div>
                        <div className={classes.Dealer}>
                            <div className={classes.DealerName}>
                                <p>{FeatruedVehicle.seller.name}</p>
                                <img src={fullStar} alt='rate1' />
                                <img src={fullStar} alt='rate2' />
                                <img src={fullStar} alt='rate3' />
                                <img src={halfStar} alt='rate4' />
                                <img src={emptyStar} alt='rate5' />
                            </div>
                        </div>
                        <div className={classes.Dealercontact}>
                            <small onClick={() => {
                                props.onToggelContactNow(FeatruedVehicle.seller.id, FeatruedVehicle.seller.name, FeatruedVehicle.seller.phone)
                            }}>contact Now</small>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onToggelContactNow: (id, name, phone) => { dispatch(actionCreators.toggelContactShow(id, name, phone)) }
    }
}

export default connect(null, mapDispatchToProps)(RecentVehicle)